import api from "./api";
import { API_LICENSES } from "../constants/urls";

/**
 * Servicio para buscar, crear, modificar y eliminar licencias
 * Definición del objecto de licencias
 * @param {object} license License object
 * @param {string} license.system Nombre de la licencia
 * @param {Date} license.expired_date Fecha de expiracipon de la licencia
 * @param {string} license.details Detalles de la licencia
 * @param {Object} license.company Compañía a la cual pertenece la sucursal.
 * @param {number} license.company.id Id de la compañía a la cual pertenece la sucursal.
 * @param {Object[]} license.branchesList Array de objetos sucursales
 * @returns
 */

const noCompany = { name: "Sin Compañía", id: -1 };

export const license = {
    getAll: async () => {
        return (await api.get(API_LICENSES)).data;
    },
    getById: async (id) => (await api.get(`${API_LICENSES}/${id}`)).data,
    create: async (license) => {
        return (await api.post(API_LICENSES, license)).data;
    },
    update: async (license) =>
        (await api.put(`${API_LICENSES}/${license.id}`, license)).data,
    delete: async (id) => (await api.delete(`${API_LICENSES}/${id}`)).data,
};
